export const FETCH_UNKNOWN_WORDS = {
  START: 'START_FETCH_UNKNOWN_WORDS',
  COMPLETE: 'COMPLETE_FETCH_UNKNOWN_WORDS',
  FAIL: 'FAIL_FETCH_UNKNOWN_WORDS',
  CLEANUP: 'CLEANUP_FETCH_UNKNOWN_WORDS',
}

export const CONFIRM_UNKNOWN_WORD = {
  START: 'START_CONFIRM_UNKNOWN_WORD',
  COMPLETE: 'COMPLETE_CONFIRM_UNKNOWN_WORD',
  FAIL: 'FAIL_CONFIRM_UNKNOWN_WORD',
}

export const DELETE_NOT_EXPORTED_UNKNOWN_WORD = {
  START: 'START_DELETE_NOT_EXPORTED_UNKNOWN_WORD',
  COMPLETE: 'COMPLETE_DELETE_NOT_EXPORTED_UNKNOWN_WORD',
  FAIL: 'FAIL_DELETE_NOT_EXPORTED_UNKNOWN_WORD',
}

export const UNCONFIRM_UNKNOWN_WORD = {
  START: 'START_UNCONFIRM_UNKNOWN_WORD',
  COMPLETE: 'COMPLETE_UNCONFIRM_UNKNOWN_WORD',
  FAIL: 'FAIL_UNCONFIRM_UNKNOWN_WORD',
}
